import { Router } from '@angular/router'
import { AuthService } from './auth.service'
import { Injectable } from '@angular/core'
import { USER } from './constants'
import { MainResponseStatus } from '../../shared/enums/main-response-status'
import { ToastrService } from 'ngx-toastr'

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private authService: AuthService, private router: Router, public toasterService: ToastrService,) {}
  handle401Error() {
    const user = JSON.parse(localStorage.getItem(USER))
    const payload = {
      refreshToken: user.refreshToken,
    }

    this.authService.getAccessTokenByRefreshToken(payload).subscribe(
      result => {
        if (result.status === MainResponseStatus.Success) {
          user.token = result.data
          localStorage.setItem(USER, JSON.stringify(user))
          location.reload() // temporary solution
        } else {
          localStorage.removeItem(USER);
          this.toasterService.error('Session expired. Please log in again', 'Error');
          this.router.navigate(['/login'])
        }
      },
      () => {
        localStorage.removeItem(USER);
        this.toasterService.error('Session expired. Please log in again', 'Error');
        this.router.navigate(['/login'])
      } 
    )
  }
}
